import { c as _c } from "react/compiler-runtime";
import { MediaInquiries } from "@/sanity/sanity.types";
import ContactInfo from "../utils/ContactInfo";
interface MediaInquiriesSectionProps {
  data: MediaInquiries;
}
const MediaInquiriesSection = t0 => {
  const $ = _c(9);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.summary) {
    t1 = data.summary && <p className="mb-4 text-base leading-6 text-[#1b2a2f]">{data.summary}</p>;
    $[0] = data.summary;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="mb-4 text-lg leading-6 font-semibold text-[#1b2a2f]">For any media and/or other corporate inquiries, please reach out:</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data.email || $[4] !== data.phone) {
    t3 = <div className="rounded-md border border-[#e5eaf4] bg-[#f6f6f6] p-8">{t2}<ContactInfo phone={data.phone} email={data.email} /></div>;
    $[3] = data.email;
    $[4] = data.phone;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default MediaInquiriesSection;